// Generated by CoffeeScript 1.12.7
(function () {
  var isBlockBrowser;

  isBlockBrowser = require("../../BlockNew/IsBlockBrowser").isBlockBrowser;

  /*
    Provides centralised list & edit functionality for block entries in a navigation widget.
  
    @param screenSide [String] - the side of the screen this navigation list appears from, can be
      either 'left' or 'right'
    @param isClosed [Function] - returns Boolean indicating whether the parent widget is in a closed
      or open state.
   */

  module.exports = function (
    screenSide,
    isClosed,
    createUi,
    project,
    projectScrollTo,
    projectNavigation,
    keyboard,
    account,
    user,
    getFullName,
  ) {
    var ui;
    return (ui = createUi(require("./NavigationList.html"), {
      blocks: project.blocks,
      isClosed: isClosed,
      showBlock: projectNavigation.showBlockInNavigation,
      screenSide: screenSide,
      project: project,
      accountName: account.name,
      userName: getFullName(user),
      userEmail: user.email,
      showHiddenBlocks: true,
      showBlock: function (block) {
        if (isBlockBrowser(block)) {
          return false;
        } else if (ui.showHiddenBlocks) {
          return true;
        } else {
          return !block.settings.navigation.exclude;
        }
      },
      hiddenBlockCount: function () {
        return _.filter(project.blocks, function (block) {
          if (isBlockBrowser(block)) {
            return false;
          } else {
            return block.settings.navigation.exclude === true;
          }
        }).length;
      },
      goto: function (block) {
        var ref;
        if (!((ref = block.settings.navigation) != null ? ref.exclude : void 0)) {
          return projectScrollTo($(block.$ctrl.ui.blockElement).parents(".top-level-block-wrapper"), {
            scrollingElement: ".content-container__scroll-container",
          });
        }
      },
      openNavConfig: function () {
        return projectNavigation.configure();
      },
      doneOnEnter: function (e, block) {
        if (keyboard.isKey(e, "ENTER")) {
          return (block.$showNavEditPanel = false);
        }
      },
      isEmptyState: function () {
        return _.filter(project.blocks, projectNavigation.showBlockInNavigation).length === 0;
      },
      showContactBlock: function () {
        return projectNavigation.getWidget("header").showContact || projectNavigation.getWidget("sidebar").showContact;
      },
      $onElementRendered: function (elem, property) {
        if (property === "block-name-input") {
          return $(elem).trigger("focus");
        }
      },
    }));
  };
}.call(this));
